var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M10.5 9.238c.85.427 1.577 1.112 2.109 1.968.105.17.158.254.176.371a.63.63 0 0 1-.348.627c-.11.046-.233.046-.479.046M9.333 6.727a2.625 2.625 0 0 0 0-4.704M8.167 4.375a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0m-6.674 6.672C2.423 9.651 3.89 8.75 5.542 8.75c1.65 0 3.118.901 4.048 2.297.204.306.306.46.294.655a.65.65 0 0 1-.23.43c-.156.118-.37.118-.8.118H2.23c-.43 0-.644 0-.8-.118a.65.65 0 0 1-.231-.43c-.012-.196.09-.349.294-.655"
  })));
};
export default SvgUsers;